import { ListItem, styled } from "@mui/material";

import { List } from "@/Components/v2/atoms/List";
import { Stack } from "@/Components/v2/atoms/Stack";
import { BoldSpan, Typography } from "@/Components/v2/atoms/Typography";
import { HIDE_DECIMAL, NO_SYMBOL } from "@/hooks/useConfig";
import { FormatCurrencyFunction } from "@/hooks/useConfig/types";
import { ToolTipLegendCircle } from "@/Utils/ECharts/ToolTipLegendCircle";

interface ToolTipSpendDollarProps {
  revenue: { seriesName: string; value: string | number; color: string }[];
  spend: { seriesName: string; value: string | number; color: string }[];
  totalRevenue: number;
  totalSpend: number;
  formatCurrency: FormatCurrencyFunction;
  revenueLabel: string;
}

const ToolTipSpendDollar: React.FC<ToolTipSpendDollarProps> = ({
  revenue,
  spend,
  totalRevenue,
  totalSpend,
  formatCurrency,
  revenueLabel,
}) => {
  const filteredSpend = spend.filter((item) => item.value !== 0);
  const filteredRevenue = revenue.filter((item) => item.value !== 0);
  const revenueFormatterOptions =
    revenueLabel === "Return" ? { ...NO_SYMBOL, ...HIDE_DECIMAL } : HIDE_DECIMAL;

  return (
    <ToolTipContainer>
      {/* Spend */}
      <Stack paddingTop={1} paddingRight={4} alignItems="flex-start">
        <Typography variant="body1" fontWeight={600}>
          Marketing Spend
        </Typography>
        <List>
          {filteredSpend.map((item, index) => (
            <ListItem key={index}>
              <ToolTipLegendCircle color={item.color} border={item.color} />
              <Typography variant="body2">
                <BoldSpan>{item.seriesName.split(" ")[0]}</BoldSpan>
                <Typography>{formatCurrency(Number(item.value), HIDE_DECIMAL)}</Typography>
              </Typography>
            </ListItem>
          ))}
          <ListItem>
            <Typography variant="body2">
              <BoldSpan>Total Spend</BoldSpan>
              <Typography>{formatCurrency(totalSpend, HIDE_DECIMAL)}</Typography>
            </Typography>
          </ListItem>
        </List>
      </Stack>

      {/* Revenue */}
      <Stack paddingTop={1} paddingRight={1} alignItems="flex-start">
        <Typography variant="body1" fontWeight={600}>
          Marketing {revenueLabel}
        </Typography>
        <List>
          {filteredRevenue.map((item, index) => (
            <ListItem key={index}>
              <ToolTipLegendCircle color={item.color} border={item.color} />
              <Typography variant="body2">
                <BoldSpan>{item.seriesName.split(" ")[0]}</BoldSpan>
                <Typography>
                  {formatCurrency(Number(item.value), revenueFormatterOptions)}
                </Typography>
              </Typography>
            </ListItem>
          ))}
          <Stack>
            <ListItem>
              <Typography variant="body2">
                <BoldSpan>Total {revenueLabel}</BoldSpan>
                <Typography>{formatCurrency(totalRevenue, revenueFormatterOptions)}</Typography>
              </Typography>
            </ListItem>
          </Stack>
        </List>
      </Stack>
    </ToolTipContainer>
  );
};

export default ToolTipSpendDollar;

const ToolTipContainer = styled("div")(() => {
  return {
    display: "flex",
  };
});
